<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader class="p-1">
                        <CRow>
                            <CCol col="4" style="text-align: start ;padding:10px 20px 0 20px ">

                                <strong>{{$t('supplierProducts')}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: center ;padding:10px 20px 0 20px ">

                                <strong>{{supplier_name}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">


                                <CButton v-if="status_form==0" class="mr-1 ml-1"  @click="insert_data()" type="submit" size="sm"
                                         color="secondary">
                                    {{ $t('buttons.submit') }}
                                </CButton>

                              <CButton  class="mr-1 ml-1"  @click="open_new_product()" type="submit" size="sm"
                                        color="secondary">
                                {{ $t('newItem') }}
                              </CButton>
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.cancel") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <BTabs>
                            <CTab :title="$t('supplierProducts')">
                                <CDataTable
                                        :items="supplier_items"
                                        :fields="fields_supplier"
                                        column-filter
                                        border
                                        striped
                                        :items-per-page="20"
                                        hover
                                        sorter
                                        pagination
                                >
                                    <template #row="{item}">

                                        <td style="text-align: center">
                                            <p >{{ item.row_id + 1 }}</p>

                                        </td>

                                    </template>


                                    <template #vat="{item}">

                                        <td>
                                            <CInput
                                                    :value.sync="item.vat"
                                                    :placeholder="$t('vatRate')"
                                            />

                                        </td>

                                    </template>

                                    <template #off="{item}">

                                        <td>
                                            <CInput
                                                    :value.sync="item.takhfif"
                                                    :placeholder="$t('components.off')"
                                            />

                                        </td>

                                    </template>

                                    <template #price="{item}">

                                        <td>
                                            <CInput
                                                    :value.sync="item.salePrice"
                                                    :placeholder="$t('components.price')"
                                            />

                                        </td>

                                    </template>
                                    <template #supply="{item}">

                                        <td>
                                            <CInput
                                                    :value.sync="item.supply"
                                                    :placeholder="$t('components.existence')"
                                            />

                                        </td>

                                    </template>


                                    <template #operation="{item}">
                                        <td>

                                            <CButton
                                                    color="dark"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="update_data(item)"
                                            >
                                                <CIcon size="sm" name="cil-pencil"></CIcon>

                                            </CButton>
                                            <CButton
                                                    color="dark"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="delete_item_dialog(item)"
                                            >
                                                <CIcon size="sm" name="cil-trash"></CIcon>

                                            </CButton>

                                        </td>
                                    </template>


                                </CDataTable>


                            </CTab>
                          <CTab :title="$t('items')">

                            <CCardBody>

                              <CRow>


                                <CCol col="2">
                                  <CSelect
                                      :value.sync=selected_cat
                                      :options="cats"
                                  />

                                </CCol>
                                <CCol col="2">
                                  <CSelect
                                      :value.sync=selected_brand
                                      :options="brands"
                                  />

                                </CCol>
                                <CCol col="2">

                                  <CInput
                                      :placeholder="$t('components.search')"
                                      v-model="product_search"
                                  />
                                </CCol>
                              </CRow>


                            </CCardBody>
                            <CCard>

                              <CCardBody>
                                <CDataTable
                                    :items="product_items"
                                    :fields="fields"
                                    column-filter
                                    border
                                    :items-per-page="20"
                                    hover
                                    sorter
                                    @row-clicked="table_row_clicked"

                                    pagination
                                >
                                  <template #row="{item}">

                                    <td style="text-align: center">
                                      <p >{{ item.row_id + 1 }}</p>

                                    </td>

                                  </template>


                                  <template #vat="{item}">
                                    <td>
                                      <CInput
                                          :value.sync="item.vat"
                                          :placeholder="$t('vatRate')"
                                      />
                                    </td>
                                  </template>
                                  <template #sup_product_name="{item}">
                                    <td>
                                      <CInput
                                          :value.sync="item.sup_product_name"
                                          :placeholder="$t('supplierProductName')"
                                      />
                                    </td>
                                  </template>
                                  <template #sup_product_code="{item}">
                                    <td>
                                      <CInput
                                          :value.sync="item.sup_product_code"
                                          :placeholder="$t('supplierProductCode')"
                                      />
                                    </td>
                                  </template>

                                  <template #off="{item}">

                                    <td>
                                      <CInput
                                          :value.sync="item.takhfif"
                                          :placeholder="$t('components.off')"
                                      />

                                    </td>

                                  </template>

                                  <template #price="{item}">

                                    <td>
                                      <CInput
                                          :value.sync="item.salePrice"
                                          :placeholder="$t('components.price')"
                                      />

                                    </td>

                                  </template>

                                  <template #supply="{item}">

                                    <td>
                                      <CInput
                                          :value.sync="item.supply"
                                          :placeholder="$t('components.existence')"
                                      />

                                    </td>

                                  </template>
                                  <template #operation="{item}">
                                    <td>

                                      <CButton
                                          color="dark"
                                          variant="outline"
                                          square
                                          size="sm"
                                          @click="insert_data(item)"
                                      >
                                        <CIcon size="sm" name="cil-plus"></CIcon>

                                      </CButton>

                                    </td>
                                  </template>


                                </CDataTable>
                              </CCardBody>

                            </CCard>


                          </CTab>

                        </BTabs>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import BTabs from "@/views/tabs/BTabs";


    export default {
        name: 'Login',
      components: {BTabs},
      data() {
            return {
                supplier_name:'',
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                selected_cat: 0,
                cats: [],
                selected_brand: 0,
                brands: [],
                product_search: '',
                supplier_items: [],
                product_items: [],
                status_form: 0,
                fields: [

                ],
                fields_supplier: [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                  {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},

                    {key: 'productName', label: this.$t('components.productName'), _style: 'width:15%'},
                    {key: 'categoryName', label: this.$t('productGroup'), _style: 'width:15%'},
                  {key: 'productCode', label: this.$t('supplierProductCode'), _style: 'width:10%'},

                  {key: 'productCode', label: this.$t('supplierProductName'), _style: 'width:15%'},
                    {key: 'productCode', label: this.$t('tables.barcode'), _style: 'width:10%'},
                    // {key: 'productCode', label: "دسته بندی", _style: 'width:7%'},
                  {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
                  {key: 'vat', label: this.$t('tables.tax'), _style: 'width:5%;'},
                  {key: 'off', label: this.$t('tables.off'), _style: 'width:5%;'},

                    // {key: 'productCode', label: this.$t('tables.status'), _style: 'width:5%'},
                    // {key: 'productCode', label: "VAT", _style: 'width:5%'},
                    // {key: 'supply', label: this.$t('components.existence'), _style: 'width:10%;'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;'},
                ],
            }
        }, mounted() {
          if(this.get_access('sell_method')){
            this.fields= [
              {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
              {key: 'productName', label: this.$t('components.productName'), _style: 'width:15%'},
              {key: 'productCode', label: this.$t('components.productCode'), _style: 'width:10%'},
              // {key: 'sup_product_name', label: "نام کالا تامین کننده", _style: 'width:15%;'},
              // {key: 'sup_product_code', label: "کد کالا تامین کننده", _style: 'width:10%;'},

              {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
              {key: 'off', label: this.$t('tables.off'), _style: 'width:5%;'},
              {key: 'vat', label: this.$t('vatRate'), _style: 'width:5%;'},
              {key: 'supply', label:this.$t('components.existence'), _style: 'width:5%;'},
              {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},
            ];
          }else{
            this.fields= [
              {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
              {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},

              {key: 'productName', label: this.$t('components.productName'), _style: 'width:15%'},
              {key: 'sup_product_code', label: this.$t('supplierProductCode'), _style: 'width:10%;'},

              {key: 'sup_product_name', label: this.$t('supplierProductName'), _style: 'width:15%;'},

              {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
              {key: 'vat', label: this.$t('tables.tax'), _style: 'width:5%;'},

              {key: 'off', label: this.$t('tables.off'), _style: 'width:5%;'},
              // {key: 'supply', label: this.$t('components.existence'), _style: 'width:5%;'},
              {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},
            ]
          }
            this.$root.root_validate_errors = [];
            this.get_brands();
            this.get_categories();
            this.get_supplier_lists();
            this.get_suppliers();
            bus.$on(this.confirm_delete_name, (data) => {
                if (data == "true") {
                    this.delete_item();
                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'selected_cat': function () {
                if (this.product_search.length >= 2) {
                    this.get_product_lists();
                }
            },
            'selected_brand': function () {
                if (this.product_search.length >= 2) {
                    this.get_product_lists();
                }
            },
            'product_search': function () {
                if (this.product_search.length >= 2) {
                    this.get_product_lists();
                }
            }
        },
        methods: {
          open_new_product(){
            window.open('/dashboard/products/create')
          },
          table_row_clicked(item, index,column) {


            this.product_search = item.productName;
          },
            get_suppliers() {
                var self = this;


                const formData = new FormData();
                var url = "GetAllPersons";

                formData.append('IsVendor', true);
                formData.append('IsWorker', false);
                formData.append('IsCustomer', false);
                formData.append('IsActive', 0);


                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
var selected_user =content_data.data.filter(x=> x.userId==self.$route.params.user_id)[0];

                        self.supplier_name = selected_user.personCode+" "+selected_user.fullName

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_brands() {
                var self = this;

              this.$apis.get_brands(this.$t('allBrands')).then(result => {
                self.brands = result

              })


            },
            get_categories() {
                var self = this;
                const formData = new FormData();
                axios.post('GetAllCats', formData, {}).then(function (response) {
                    var content_data = response.data;
                    if (content_data.statusCode == 0) {

                        self.cats = [];
                        var obj = {label: self.$t('allCategories'), value: 0}
                        self.cats.push(obj);
                        self.cats = self.sort_array(
                            self.cats, content_data.data,
                            'catTitleId', 'catTitle');

                        // content_data.data.forEach((val) => {
                        //   var obj = {label: val.catTitle, value: val.catTitleId}
                        //   self.cats.push(obj);
                        // });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            validateForm: function (item) {
              console.log("validate item ",item)
                this.$root.root_validate_errors = [];

                if (item.supply != null && item.supply != '' && item.supply != '0') {
                    return true;
                }else {
                    this.$root.root_validate_errors.push(this.$t('insertExistence'));
                    return false;

                }

            },


            get_product_lists() {
                var self = this;

                const formData = new FormData();

                formData.append('Id', this.selected_cat);
                formData.append('BrandId', this.selected_brand);
                formData.append('SearchTxt', this.product_search);
                formData.append('PersonId', this.$route.params.user_id);

                axios.post('GetProductsForSupplier', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.product_items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_supplier_lists() {
                var self = this;

                const formData = new FormData();

                formData.append('PersonId', this.$route.params.user_id);


                axios.post('GetSupplierProducts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.supplier_items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            insert_data(item, index) {

                if (!this.validateForm(item)) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                // if (this.status_form == 0) {
                    url = "AddSupplierProduct";
                // } else {
                //     url = "EditMainCat";
                //     formData.append('Id', item.id)
                // }

                if(!item.salePrice){
                    item.salePrice = '0';
                }
                if(!item.takhfif){
                    item.takhfif = '0';
                }
                if(!item.vat){
                    item.vat = '0';
                }
                formData.append('ProductId', item.id);
                formData.append('SalePrice', item.salePrice);
                formData.append('IsPercentDiscount', true);
                formData.append('Takhfif', item.takhfif);
                formData.append('Vat', item.vat);
                formData.append('Supply', item.supply);

                if(item.sup_product_name== null || item.sup_product_name== ""){
                    formData.append('SuppProductName', "");
                    formData.append('SuppProductCode', "");
                }else{
                  formData.append('SuppProductName', item.sup_product_name);
                  formData.append('SuppProductCode', item.sup_product_code);
                }
                formData.append('PersonId', this.$route.params.user_id);
                formData.append('Summary', "");

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);
                    if (self.status_form == 0) {
                        self.product_items.splice(index, 1);
                    }
                    self.status_form = 0;

                    self.get_supplier_lists();

                }).catch(function (error) {
                    console.log(error);
                });

            },
            update_data(item, index) {

                if (!this.validateForm(item)) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                // if (this.status_form == 0) {
                    url = "EditSupplierProduct";
                // } else {
                //     url = "EditMainCat";
                //     formData.append('Id', item.id)
                // }

                formData.append('Id', item.recId);
                formData.append('ProductId', item.productId);
                formData.append('SalePrice', item.salePrice);
                formData.append('IsPercentDiscount', true);
                formData.append('Takhfif', item.takhfif);
                formData.append('Vat', item.vat);
                formData.append('Supply', item.supply);

                if(item.sup_product_name== null || item.sup_product_name== ""){
                    formData.append('SuppProductName', "");
                    formData.append('SuppProductCode', "");
                }else{
                  formData.append('SuppProductName', item.sup_product_name);
                  formData.append('SuppProductCode', item.sup_product_code);

                }
                formData.append('PersonId', this.$route.params.user_id);
                formData.append('Summary', "");

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);
                    if (self.status_form == 0) {
                        self.product_items.splice(index, 1);
                    }
                    self.status_form = 0;

                    self.get_supplier_lists();

                }).catch(function (error) {
                    console.log(error);
                });

            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.recId;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteSupplierProduct";


                formData.append('Id', this.status_form);

                axios.post(url, formData, {}).then((res) => {
                  self.$root.modal_component.show_api_response_modals(res);
                    self.status_form = 0;

                    self.get_supplier_lists();
                })
                    .catch(function (error) {
                        console.log(error);
                    });
// this.get_categories();7
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
